import { render } from "./AppShell.vue?vue&type=template&id=865b5020&scoped=true"
import script from "./AppShell.vue?vue&type=script&lang=js"
export * from "./AppShell.vue?vue&type=script&lang=js"

import "./AppShell.vue?vue&type=style&index=0&id=865b5020&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mridu\\BGI_Project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-865b5020"]])

export default __exports__